import {useCallback} from 'react'
import {useDispatch} from 'react-redux'
// import config from '../../config'
import {GET_COORDS} from './actionTypes'
// import fetchData, {fetchContent} from '../../utils/fetch-data'
// import {getCookie, setCookie} from '../../utils/cookie'
// import config from '../../config'
// import isMobileDevice from '../../utils/isMobileDevice'
// import activateGeolocateMobile from '../../utils/activateGeolocateMobile'
import getGeolocation from '../../hooks/getGeolocation'

// const homePage = process.env.NODE_ENV === 'development' ? true : window.theme.isHomePage
// const cityAlias = !homePage ? window.theme.cityAlias : false

export const changeCoordsStateAction = state => ({
  type: GET_COORDS,
  payload: state,
})

const useCoordsActions = () => {
  const dispatch = useDispatch()
  const setCoords = useCallback(async () => {
    try {
      const crd = await getGeolocation()
      dispatch({
        type: GET_COORDS,
        payload: crd,
      })
    } catch (error) {
      console.debug(`useCoordsActions error: ${error}`)
    }
  }, [dispatch])

  const postCoords = useCallback(
    coords => {
      dispatch({
        type: GET_COORDS,
        payload: coords,
      })
    },
    [dispatch]
  )

  return {setCoords, postCoords}
}

export default useCoordsActions
